// 使用CDN引入的VueRouter全局变量
const { createRouter, createWebHashHistory } = VueRouter
import { getApiBaseUrl } from './utils/runtime'

const isMobileBrowser = () => {
  if (typeof window === 'undefined') return false
  return /Android|iPhone|iPad|iPod|Mobile/i.test(window.navigator.userAgent) || window.innerWidth < 768
}

let verifiedToken = ''
let verifyingTokenPromise = null

const clearLoginState = () => {
  localStorage.removeItem('token')
  localStorage.removeItem('username')
  verifiedToken = ''
}

const verifyToken = async (token) => {
  if (!token) return false
  if (verifiedToken === token) return true

  if (!verifyingTokenPromise) {
    verifyingTokenPromise = fetch(`${getApiBaseUrl()}/auth/me`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(async response => {
        if (response.status === 401 || response.status === 403) {
          return false
        }
        if (!response.ok) {
          return true
        }
        const data = await response.json().catch(() => null)
        return data && (data.code === 200 || data.code === '200')
      })
      .catch(() => true)
      .finally(() => {
        verifyingTokenPromise = null
      })
  }

  const isValid = await verifyingTokenPromise
  if (isValid) {
    verifiedToken = token
  } else if (verifiedToken === token) {
    verifiedToken = ''
  }
  return isValid
}

const routes = [
  {
    path: '/',
    redirect: () => (isMobileBrowser() ? '/mobile' : '/home')
  },
  {
    path: '/home',
    name: 'PcHome',
    component: () => import('./views/PcHome.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('./views/Login.vue')
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('./views/Login.vue')
  },
  {
    path: '/store-management',
    name: 'StoreManagement',
    component: () => import('./views/StoreManagement.vue')
  },
  {
    path: '/jieshun-sync',
    name: 'JieshunSync',
    component: () => import('./views/JieshunSync.vue')
  },
  {
    path: '/add-store',
    name: 'AddStore',
    component: () => import('./views/AddStore.vue')
  },
  {
    path: '/channel-management/:storeId?',
    name: 'ChannelManagement',
    component: () => import('./views/ChannelManagement.vue')
  },
  {
    path: '/product-management',
    name: 'ProductManagement',
    component: () => import('./views/ProductManagement.vue')
  },
  {
    path: '/product-init',
    name: 'ProductInit',
    component: () => import('./views/ProductInit.vue')
  },
  {
    path: '/store-products',
    name: 'StoreProducts',
    component: () => import('./views/StoreProducts.vue')
  },
  {
    path: '/procurement/purchase-list',
    name: 'PurchaseList',
    component: () => import('./views/PurchaseList.vue')
  },
  {
    path: '/procurement/suppliers/new',
    name: 'SupplierCreate',
    component: () => import('./views/SupplierForm.vue')
  },
  {
    path: '/procurement/suppliers/:id/edit',
    name: 'SupplierEdit',
    component: () => import('./views/SupplierForm.vue')
  },
  {
    path: '/procurement/:section',
    name: 'PcProcurement',
    component: () => import('./views/PcProcurement.vue')
  },
  {
    path: '/inventory/:mode',
    name: 'PcInventory',
    component: () => import('./views/PcInventory.vue')
  },
  {
    path: '/unmanned-warehouse',
    name: 'UnmannedWarehouse',
    component: () => import('./views/UnmannedWarehouse.vue')
  },
  {
    path: '/lock-setting',
    name: 'lockSetting',
    component: () => import('./views/LockSetting.vue')
  },
  {
    path: '/order-complex',
    name: 'OrderComplex',
    component: () => import('./views/OrderComplex.vue')
  },
  {
    path: '/taobao-orders',
    name: 'TaobaoOrderManagement',
    component: () => import('./views/TaobaoOrderManagement.vue')
  },
  {
    path: '/monitor-setting',
    name: 'MonitorSetting',
    component: () => import('./views/MonitorSetting.vue')
  },
  {
    path: '/authorize-bind',
    name: 'AuthorizeBind',
    component: () => import('./views/AuthorizeBind.vue')
  },
  {
    path: '/h5',
    name: 'H5',
    component: () => import('./views/H5.vue')
  },
  {
    path: '/mobile',
    name: 'MobileConsole',
    component: () => import('./views/MobileConsole.vue')
  },
  {
    path: '/mobile/procurement/:mode',
    name: 'MobileProcurement',
    component: () => import('./views/MobileProcurement.vue')
  },
  {
    path: '/mobile/inventory/:mode',
    name: 'MobileInventory',
    component: () => import('./views/MobileInventory.vue')
  },
  {
    path: '/pick',
    name: 'Pick',
    component: () => import('./views/Pick.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

const publicRoutes = new Set(['/login', '/forgot-password', '/h5', '/pick'])

router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('token')
  const isPublicRoute = publicRoutes.has(to.path)

  if (isPublicRoute) {
    if (to.path === '/login' && token) {
      const isValid = await verifyToken(token)
      if (isValid) {
        next(isMobileBrowser() ? '/mobile' : '/home')
        return
      }
      clearLoginState()
    }
    next()
    return
  }

  if (!token) {
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }

  const isValid = await verifyToken(token)
  if (!isValid) {
    clearLoginState()
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }

  next()
})

export default router
